import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import apiCalls from '../utils/apiCalls';
import utils from '../utils/utils';
import Loader from '../components/loader';
import ErrorMessage from '../components/errorMessage';
import { Link, withRouter } from 'react-router-dom';

const MarketplaceAdminDeliveryDayCombined = ({ deliveryDayMarketplace, deliveryDayMarketplaceId }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [combinedOrderItems, setCombinedOrderItems] = useState(null);

  useEffect(() => {
    if (!deliveryDayMarketplace.combinedOrderItems.length) {
      setLoading(true);
      setError(null);

      apiCalls
        .getCombinedOrderItems({
          deliveryDayMarketplaceId: deliveryDayMarketplaceId,
        })
        .then((result) => {
          if (result.data && result.data.combinedOrderItems) {
            setCombinedOrderItems(result.data.combinedOrderItems);
            setLoading(false);
          }
        })
        .catch((errors) => {
          setError(utils.getErrorMessageFromResponse(errors));
          setLoading(false);
        });
    }
  }, []);

  const { formatMessage } = useIntl();

  return (
    <div className="row">
      <div className="col-12 col-sm-10 col-md-8 col-lg-6">
        <Loader show={loading} />
        <ErrorMessage error={error} />

        <table className="table table-striped admin__table">
          <thead>
            <tr>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.table.item.name'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.table.quantity'} />
              </th>
              <th scope="col">
                <FormattedMessage id={'marketplace.admin.delivery.day.orders.table.fulfilled.quantity'} />
              </th>
            </tr>
          </thead>
          <tbody>
            {deliveryDayMarketplace.combinedOrderItems
              ? deliveryDayMarketplace.combinedOrderItems.map((coi) => {
                  const textStyle =
                    coi.fulfilledQuantity !== null && coi.fulfilledQuantity < coi.orderedQuantity
                      ? 'text-danger'
                      : coi.fulfilledQuantity !== null && coi.fulfilledQuantity > coi.orderedQuantity
                      ? 'text-info'
                      : '';

                  return (
                    <tr key={coi.id}>
                      <td className={textStyle}>
                        #{coi.item.id} {utils.getItemName(coi.item, formatMessage)}
                      </td>
                      <td>{coi.orderedQuantity}</td>
                      <td className={textStyle}>{coi.fulfilledQuantity !== null ? coi.fulfilledQuantity : '-'}</td>
                    </tr>
                  );
                })
              : ''}
            {combinedOrderItems
              ? combinedOrderItems.map((combinedOrderItem, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      <th>
                        <Link to={`/item/${combinedOrderItem.orderItem.item.id}`}>
                          #{combinedOrderItem.orderItem.item.id} {combinedOrderItem.orderItem.itemName}
                        </Link>
                      </th>
                      <td>{combinedOrderItem.quantity}</td>
                      <td>-</td>
                    </tr>
                  );
                })
              : ''}
          </tbody>
        </table>
      </div>
    </div>
  );
};

MarketplaceAdminDeliveryDayCombined.propTypes = {
  deliveryDayMarketplaceId: PropTypes.number.isRequired,
};

MarketplaceAdminDeliveryDayCombined.defaultProps = {};

export default withRouter(MarketplaceAdminDeliveryDayCombined);
